import { dehydrate, QueryClient } from '@tanstack/react-query'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'
import Comments from 'components/Comments'
import LightGalery from 'components/LightGalery'
import PostCover from 'components/Post/Cover'

import * as S from './styles.slug'
import { getDetail, getList } from 'services/tips/action'
import { useList } from 'services/tips'
import { countComments, transformHttpToHttps } from 'utils'
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'

const Slug = ({ data }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const { push } = useRouter()

  const { data: relatedGrass } = useList()
  const relatedGrassSpllited = relatedGrass?.slice(0, 6)
  const bodyRef = useRef(null)

  useEffect(() => {
    const jsSnippetWithoutReplace = data?.acf?.snippets
    const jsSnippet = jsSnippetWithoutReplace?.replace(
      '_reviewCount_',
      countComments(data?.acf?.comments)
    )

    const scriptTag = document.querySelector(
      'script[type="application/ld+json"]'
    )
    scriptTag?.remove()

    if (!scriptTag && jsSnippet) {
      document
        ?.querySelector('body')
        ?.insertAdjacentHTML('beforeend', jsSnippet)
    }
    return () => {
      const script = document.querySelector(
        'script[type="application/ld+json"]'
      )
      script?.remove()
    }
  }, [data?.acf])

  function removeTrace(string) {
    return string.replace(/-/g, ' ')
  }

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 445)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Layout
      category={data?.title?.rendered}
      title={data?.acf?.seo?.title}
      subtitle={data?.acf?.seo?.title}
      description={data?.acf?.seo?.description}
      h2={data?.acf?.seo?.description}
      keywords={data?.acf?.seo?.keywords}
      categorySize="1.6rem"
    >
      <section>
        <Container>
          <S.Flex>
            <S.Left>
              <PostCover
                cover={
                  isSmallScreen
                    ? transformHttpToHttps(data?.x_featured_media_original)
                    : transformHttpToHttps(data?.acf?.capa_dicas_img)
                }
                description={
                  isSmallScreen
                    ? data?.excerpt?.rendered
                    : data?.acf?.capa_dicas_alt
                }
                title={
                  isSmallScreen
                    ? data?.title?.rendered?.toLowerCase()
                    : data?.acf?.capa_dicas_title
                }
              />
              <S.About>
                <S.Item>
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.09091 0C5.58636 0 2.72727 2.85909 2.72727 6.36364C2.72727 8.55455 3.84545 10.5 5.54 11.6482C2.29727 13.0391 0 16.2573 0 20H1.81818C1.81818 15.9727 5.06364 12.7273 9.09091 12.7273C13.1182 12.7273 16.3636 15.9727 16.3636 20H18.1818C18.1818 16.2573 15.8845 13.04 12.6418 11.6473C13.5067 11.0634 14.2153 10.2765 14.7056 9.35544C15.196 8.43435 15.4531 7.40712 15.4545 6.36364C15.4545 2.85909 12.5955 0 9.09091 0ZM9.09091 1.81818C11.6118 1.81818 13.6364 3.84273 13.6364 6.36364C13.6364 8.88455 11.6118 10.9091 9.09091 10.9091C6.57 10.9091 4.54545 8.88455 4.54545 6.36364C4.54545 3.84273 6.57 1.81818 9.09091 1.81818Z"
                      fill="#4B5563"
                    />
                  </svg>
                  <S.AboutText>{data?.x_author}</S.AboutText>
                </S.Item>
                <S.Item>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.5156 1.87546H15.8072V0.62543C15.8073 0.459666 15.7416 0.300648 15.6244 0.183357C15.5073 0.066066 15.3484 0.000110658 15.1826 1.48406e-07C15.0169 -0.000110361 14.8578 0.0656331 14.7405 0.182768C14.6233 0.299902 14.5573 0.458833 14.5572 0.624596V1.87546H10.8071V0.62543C10.8072 0.543352 10.791 0.462067 10.7597 0.386216C10.7283 0.310365 10.6823 0.241433 10.6243 0.183357C10.5663 0.12528 10.4975 0.0791963 10.4217 0.0477359C10.3459 0.0162755 10.2646 5.48577e-05 10.1825 1.39092e-07C10.0167 -0.00011037 9.85773 0.065633 9.74044 0.182768C9.62315 0.299902 9.55719 0.458833 9.55708 0.624596V1.87546H5.807V0.62543C5.80706 0.543352 5.79094 0.462067 5.75959 0.386216C5.72823 0.310365 5.68223 0.241433 5.62423 0.183357C5.56624 0.12528 5.49737 0.0791963 5.42156 0.0477359C5.34575 0.0162755 5.26448 5.48577e-05 5.18241 1.39092e-07C5.01664 -0.00011037 4.85762 0.065633 4.74033 0.182768C4.62304 0.299902 4.55709 0.458833 4.55698 0.624596V1.87546H1.84859C1.40669 1.87546 0.982888 2.05094 0.670345 2.36333C0.357802 2.67571 0.182106 3.09943 0.181885 3.54132V18.3333C0.181885 18.7753 0.357483 19.1993 0.67005 19.5118C0.982617 19.8244 1.40655 20 1.84859 20H18.5156C18.9576 20 19.3816 19.8244 19.6941 19.5118C20.0067 19.1993 20.1823 18.7753 20.1823 18.3333V3.54132C20.1821 3.09943 20.0064 2.67571 19.6938 2.36333C19.3813 2.05094 18.9575 1.87546 18.5156 1.87546ZM18.9323 18.3341C18.9323 18.4445 18.8885 18.5504 18.8105 18.6285C18.7326 18.7066 18.6268 18.7506 18.5164 18.7508H1.84859C1.73808 18.7508 1.63209 18.7069 1.55395 18.6288C1.47581 18.5506 1.43191 18.4446 1.43191 18.3341V3.54216C1.43213 3.43179 1.47613 3.32602 1.55425 3.24806C1.63236 3.1701 1.73822 3.12631 1.84859 3.12632H4.55698V4.37634C4.55687 4.5421 4.62261 4.70112 4.73974 4.81841C4.85688 4.9357 5.01581 5.00166 5.18157 5.00177C5.34734 5.00188 5.50635 4.93614 5.62365 4.819C5.74094 4.70187 5.80689 4.54294 5.807 4.37717V3.12632H9.55708V4.37634C9.55697 4.5421 9.62271 4.70112 9.73985 4.81841C9.85698 4.9357 10.0159 5.00166 10.1817 5.00177C10.3474 5.00188 10.5065 4.93614 10.6237 4.819C10.741 4.70187 10.807 4.54294 10.8071 4.37717V3.12632H14.5572V4.37634C14.5571 4.5421 14.6228 4.70112 14.74 4.81841C14.8571 4.9357 15.016 5.00166 15.1818 5.00177C15.3475 5.00188 15.5066 4.93614 15.6239 4.819C15.7411 4.70187 15.8071 4.54294 15.8072 4.37717V3.12632H18.5156C18.6258 3.12654 18.7315 3.17042 18.8094 3.24836C18.8873 3.32629 18.9312 3.43194 18.9314 3.54216L18.9323 18.3341Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M4.55698 7.50057H7.05703V9.37561H4.55698V7.50057Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M4.55698 10.6256H7.05703V12.5007H4.55698V10.6256Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M4.55698 13.7507H7.05703V15.6257H4.55698V13.7507Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M8.93207 13.7507H11.4321V15.6257H8.93207V13.7507Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M8.93207 10.6256H11.4321V12.5007H8.93207V10.6256Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M8.93207 7.50057H11.4321V9.37561H8.93207V7.50057Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M13.3072 13.7507H15.8072V15.6257H13.3072V13.7507Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M13.3072 10.6256H15.8072V12.5007H13.3072V10.6256Z"
                      fill="#4B5563"
                    />
                    <path
                      d="M13.3072 7.50057H15.8072V9.37561H13.3072V7.50057Z"
                      fill="#4B5563"
                    />
                  </svg>
                  <S.AboutText as="time">
                    {format(new Date(data.date), 'EEEE, d MMMM, Y ', {
                      locale: ptBR,
                    })}
                  </S.AboutText>
                </S.Item>
                <S.Item>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.32153 3.33569V3.12721C4.32153 2.29782 4.65101 1.50241 5.23747 0.915939C5.82394 0.329473 6.61936 0 7.44874 0H16.2049C17.4767 0 18.6963 0.505192 19.5956 1.40444C20.4948 2.30369 21 3.52333 21 4.79506V10.6242C21 11.0349 20.9191 11.4415 20.762 11.8209C20.6048 12.2003 20.3744 12.5451 20.0841 12.8355C19.7937 13.1258 19.4489 13.3562 19.0695 13.5133C18.6901 13.6705 18.2835 13.7514 17.8728 13.7514H17.6643V13.9599C17.6643 14.7893 17.3348 15.5847 16.7484 16.1711C16.1619 16.7576 15.3665 17.0871 14.5371 17.0871H9.53605L5.99605 19.7848C5.30973 20.3077 4.32153 19.8182 4.32153 18.9559V17.0871H4.11305C3.28366 17.0871 2.48825 16.7576 1.90178 16.1711C1.31531 15.5847 0.98584 14.7893 0.98584 13.9599V6.4629C0.98584 5.63352 1.31531 4.8381 1.90178 4.25163C2.48825 3.66517 3.28366 3.33569 4.11305 3.33569H4.32153ZM5.57242 3.12721V3.33569H14.5371C15.3665 3.33569 16.1619 3.66517 16.7484 4.25163C17.3348 4.8381 17.6643 5.63352 17.6643 6.4629V12.5005H17.8728C18.3704 12.5005 18.8477 12.3028 19.1995 11.9509C19.5514 11.5991 19.7491 11.1218 19.7491 10.6242V4.79506C19.7491 3.85508 19.3757 2.95361 18.711 2.28895C18.0464 1.62429 17.1449 1.25088 16.2049 1.25088H7.44874C6.95111 1.25088 6.47386 1.44857 6.12198 1.80045C5.7701 2.15233 5.57242 2.62958 5.57242 3.12721ZM2.23672 6.4629V13.9599C2.23672 14.4575 2.43441 14.9348 2.78629 15.2866C3.13817 15.6385 3.61542 15.8362 4.11305 15.8362H4.94697C5.11285 15.8362 5.27194 15.9021 5.38923 16.0194C5.50652 16.1367 5.57242 16.2958 5.57242 16.4616V18.5348L8.94647 15.9646C9.05522 15.8815 9.18822 15.8364 9.32507 15.8362H14.5371C15.0347 15.8362 15.512 15.6385 15.8639 15.2866C16.2157 14.9348 16.4134 14.4575 16.4134 13.9599V6.4629C16.4134 5.96527 16.2157 5.48802 15.8639 5.13614C15.512 4.78426 15.0347 4.58658 14.5371 4.58658H4.11305C3.61542 4.58658 3.13817 4.78426 2.78629 5.13614C2.43441 5.48802 2.23672 5.96527 2.23672 6.4629Z"
                      fill="#4B5563"
                    />
                  </svg>
                  <S.AboutText>
                    {data?.acf?.comments
                      ? countComments(data?.acf?.comments)
                      : '0'}{' '}
                    Comentários
                  </S.AboutText>
                </S.Item>
              </S.About>
              <S.Text
                ref={bodyRef}
                dangerouslySetInnerHTML={{ __html: data?.content?.rendered }}
              />
              <S.Author>
                <S.AuthorImage size="xl" name={data?.x_author}>
                  <img
                    src={transformHttpToHttps(data?.author?.author_avatar)}
                    alt={data?.x_author}
                  />
                </S.AuthorImage>
                <S.AuthorRight>
                  <S.AuthorName>{data?.x_author}</S.AuthorName>
                  <S.AuthorDescription>
                    {data?.author?.author_description}
                  </S.AuthorDescription>
                </S.AuthorRight>
              </S.Author>
              <Comments comments={data?.acf?.comments} postId={data?.id} />
            </S.Left>
            <S.Right>
              <h4>Outras dicas</h4>

              {relatedGrassSpllited?.map((item) => (
                <S.Others
                  key={`others-item-${item.id}`}
                  onClick={() => push(`/dicas/${item.slug}`)}
                >
                  <S.OthersFigure>
                    <img
                      src={transformHttpToHttps(item.x_featured_media_original)}
                      title={item?.acf?.title_img_othertips}
                      alt={item?.acf?.alt_img_othertips}
                    />
                  </S.OthersFigure>
                  <S.OthersRight>
                    <S.OthersTitle title={item?.acf?.title_text_othertips}>
                      {item.title.rendered}
                    </S.OthersTitle>
                    <S.OthersBottom>
                      <S.OthersText>{item.x_author}</S.OthersText>
                      <S.OthersText>
                        {format(new Date(item.date), 'EEEE, d MMMM, Y ', {
                          locale: ptBR,
                        })}
                      </S.OthersText>
                    </S.OthersBottom>
                  </S.OthersRight>
                </S.Others>
              ))}
            </S.Right>
          </S.Flex>
        </Container>
      </section>

      <LightGalery ref={bodyRef} body={data?.content?.rendered} />
    </Layout>
  )
}

export default Slug

export async function getServerSideProps(context) {
  const response = await getDetail(context.params?.slug)

  return {
    props: {
      data: response,
    },
  }
}
